const CardStatus = {
    ACTIVE: "ACTIVE",
    READY_TO_STAGE: "READY_TO_STAGE",
    STAGED: "STAGED",
    INACTIVE: "INACTIVE"
}

const IssueType = {
    DAMAGED: "DAMAGED",
    MISSING: "MISSING",
    WRONG_ITEM_SCANNED: "WRONG_ITEM_SCANNED",
    BAD_ITEM_SCANNED: "BAD_ITEM_SCANNED"
}

export {CardStatus, IssueType};


// WEBPACK FOOTER //
// ./src/models/enums/cart-enums.js